export default __webpack_public_path__ + "static/media/WishlistedBlip.985fdbbe.svg";